import { RequestReport } from '../common/Reporter/sendBeaconReport';
import { Report } from '../reporter/report/Report';
import LocalState, { ReporterState } from '../state/LocalState';

// This whole file is a HACK to support customer migrating off of MS Teams TLE
// See: SRV-5527 about cleanup.

interface MSTeamsTownHallHackOptions {
  appVariant?: string;
}

export function setTownHallVariable(state: LocalState, options: unknown) {
  const opts = options as MSTeamsTownHallHackOptions;
  if (opts?.appVariant === 'TownHall') {
    state.reporter.isMicrosoftTeamsTownHall = true;
  }
}

export function modifyReportHack(state: ReporterState, request: RequestReport) {
  if (!state.isMicrosoftTeamsTownHall) {
    return;
  }
  const config = (request.body.record as Report)?.general?.config;
  if (config) {
    const data = config as unknown as Record<string, boolean>;
    data.isMicrosoftTeamsTownHall = true;
  }
}
